var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.GA4)?_c('GA4'):_c('GAUA')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }